import React, { Fragment, memo, useMemo } from 'react'
import tw from 'twin.macro'
import { PartnerDriverHeader } from 'src/components/partner-driver/details/PartnerDriverHeader'
import { PartnerDriverLoadState } from 'src/components/partner-driver/details/PartnerDriverLoadState'
import { StepsCard } from 'src/components/partner-driver/steps/StepsCard'
import { buildPartnerDriverPath } from 'src/constants/routes'
import { usePartnerDriverLoader } from 'src/hooks/usePartnerDriverLoader'

/**
 * A driver's collected-data steps and their actions, split out of the driver page so that screen
 * stays a summary of cards. Reads only `/steps` — the summary row (OTP, Yardstik) is not shown here.
 */
const PartnerDriverStepsPageComponent = () => {
  const {
    driver,
    isIdValid,
    isDriverLoading,
    driverError,
    isNotFound,
    searchBackTo,
    navigationState,
    refreshDriver,
    refreshAll,
  } = usePartnerDriverLoader({ withSummary: false })

  const driverBackTo = useMemo(() => {
    return { pathname: driver ? buildPartnerDriverPath(driver.id) : searchBackTo.pathname }
  }, [driver, searchBackTo.pathname])

  return (
    <div
      data-testid="partner-driver-steps-page"
      css={tw`flex min-h-0 min-w-0 flex-1 flex-col gap-6 overflow-y-auto p-6`}
    >
      {driver ? (
        <Fragment>
          <PartnerDriverHeader
            driver={driver}
            backTo={driverBackTo}
            backLabel="Back to driver"
            backState={navigationState}
          />
          <StepsCard driver={driver} onChanged={refreshDriver} />
        </Fragment>
      ) : (
        <PartnerDriverLoadState
          isNotFound={!isIdValid || isNotFound}
          driverError={driverError}
          isDriverLoading={isDriverLoading}
          searchBackTo={searchBackTo}
          onRetry={refreshAll}
        />
      )}
    </div>
  )
}

export const PartnerDriverStepsPage = memo(PartnerDriverStepsPageComponent)
